import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { WhyProjectFlow } from "./components/WhyProjectFlow";
import { ProductSuite } from "./components/ProductSuite";
import { KeyBenefits } from "./components/KeyBenefits";
import { Workflow } from "./components/Workflow";
import { Industries } from "./components/Industries";
import { About } from "./components/About";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { PrivacyPolicy } from "./components/PrivacyPolicy";
import { PayFlow } from "./components/PayFlow";
import { FeaturedProduct } from "./components/FeaturedProduct";
import { KnowledgeCenter } from "./components/knowledge/KnowledgeCenter";
import { PaychecksArticle } from "./components/knowledge/PaychecksArticle";
import { OvertimePerDiemArticle } from "./components/knowledge/OvertimePerDiemArticle";
import { PayClarityArticle } from "./components/knowledge/PayClarityArticle";
import { GeneralAppsArticle } from "./components/knowledge/GeneralAppsArticle";
import { RefineryPayArticle } from "./components/knowledge/RefineryPayArticle";

const HomePage = () => (
  <>
    <Hero />
    <WhyProjectFlow />
    <ProductSuite />
    <KeyBenefits />
    <Workflow />
    <FeaturedProduct />
    <Industries />
    <About />
    <Contact />
  </>
);

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <div className="App">
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/payflow" element={<PayFlow />} />
            <Route path="/knowledge" element={<KnowledgeCenter />} />
            <Route path="/knowledge/paychecks" element={<PaychecksArticle />} />
            <Route path="/knowledge/overtime-perdiem" element={<OvertimePerDiemArticle />} />
            <Route path="/knowledge/pay-clarity" element={<PayClarityArticle />} />
            <Route path="/knowledge/general-apps-vs-payflow" element={<GeneralAppsArticle />} />
            <Route path="/knowledge/refinery-pay-issues" element={<RefineryPayArticle />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
          <Footer />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
